<template lang="html">
  <div class="">
    <div v-if="profile === 'client'">
      <v-text tag="h5"><b>CLÁUSULA PRIMEIRA – DO OBJETO</b></v-text>
      <p>
        1.1. A <b>CONTRATADA</b> oferece à <b>CONTRATANTE</b> por meio da
        Plataforma Vibbra, a contratação de horas de trabalho de profissional
        talent previamente selecionado e testado pela <b>CONTRATADA</b>,
        conforme detalhes indicados no "ANEXO I" deste instrumento.
      </p>
      <p>
        1.2. Eventuais adendos de horas de trabalho, ocorrerão por meio de
        termos aditivos a serem firmados pelas Partes, e serão consideradas como
        parte integrante do presente instrumento.
      </p>
      <v-text tag="h5"
        ><b>CLÁUSULA SEGUNDA – DO FUNCIONAMENTO DOS SERVIÇOS</b></v-text
      >
      <p>
        2.1. A <b>CONTRATADA</b>, em cumprimento ao objeto deste instrumento,
        acompanhará a execução das horas contratadas do profissional denominado
        <b>Vibbrante</b> presente na Plataforma Vibbra, conforme descrito nos
        <v-link :to="{ name: 'terms' }" target="_blank"
          ><b>Termos e Condições Gerais de Uso</b></v-link
        >, bem como cuidará dos trâmites de pagamento do mesmo.
      </p>
      <p>
        2.2. Através da Plataforma Vibbra, a <b>CONTRATADA</b> apresentará
        painel de acompanhamento de atividades concluídas, destacando o número
        de horas e minutos empregados na execução de cada atividade, o qual
        servirá como comprovante de execução de horas pelo profissional
        Vibbrante.
      </p>
      <v-text tag="h5"><b>CLÁUSULA TERCEIRA – DO PAGAMENTO</b></v-text>
      <p>
        3.1 A <b>CONTRATANTE</b> pagará a <b>CONTRATADA</b> antecipadamente a
        quantidade de horas que deseja que o Vibbrante execute, não sendo
        necessário pagar integralmente o volume total de horas previsto nesse
        instrumento, podendo assim, atuar com compras periódicas de volumes
        menores de horas, até o limite total de horas previsto neste contrato.
      </p>
      <p>
        3.2 A forma de pagamento ocorrerá conforme descrito no item 5 dos
        <v-link :to="{ name: 'terms' }" target="_blank"
          ><b>Termos e Condições Gerais de Uso</b></v-link
        >
        da Plataforma Vibbra.
      </p>
      <v-text tag="h5"
        ><b>CLÁUSULA QUARTA – DAS OBRIGAÇÕES E RESPONSABILIDADES</b></v-text
      >
      <p>
        4.1. A <b>CONTRATANTE</b> é responsável pelo pagamento do valor hora
        acordado, em razão do volume de horas executadas, conforme acordado no
        presente instrumento.
      </p>
      <p>
        4.2. A <b>CONTRATANTE</b> cumprirá rigorosamente com as disposições
        deste contrato, em conformidade com todas as condições aqui
        estabelecidas, bem como o disposto nos
        <v-link :to="{ name: 'terms' }" target="_blank"
          ><b>Termos e Condições Gerais de Uso</b></v-link
        >
        da Plataforma e na
        <v-link :to="{ name: 'privacy' }" target="_blank"
          ><b>Política de Privacidade</b></v-link
        >
        disponibilizados, e ainda, com toda e qualquer exigência legal aplicável
        ao presente caso.
      </p>
      <p>
        4.3. A <b>CONTRATADA</b> se compromete em auxiliar a
        <b>CONTRATANTE</b> em assuntos envolvendo o Vibbrante, adotando todas as
        providências cabíveis para a correção de quaisquer falhas ou anomalias
        detectadas, a fim de assegurar o devido cumprimento dos serviços
        contratados.
      </p>
      <v-text tag="h5"
        ><b>CLÁUSULA QUINTA – DA LIMITAÇÃO DE RESPONSABILIDADE</b></v-text
      >
      <p>
        5.1. No caso da <b>CONTRATADA</b> ser envolvida em qualquer demanda
        judicial por ação ou omissão comprovada da <b>CONTRATANTE</b>, todas as
        despesas judiciais e extrajudiciais, incluindo honorários advocatícios,
        pagas pela <b>CONTRATADA</b>, provenientes da referida demanda, deverão
        ser reembolsadas pela <b>CONTRATANTE</b>.
      </p>
      <p>
        5.2. A <b>CONTRATADA</b> não será responsável por danos pessoais ou
        qualquer prejuízo incidental, especial, indireto ou consequente,
        incluindo, sem limitação, prejuízos por perda de lucro, corrupção ou
        perda de dados, não continuidade do negócio ou qualquer outro prejuízo
        ou perda comercial, decorrentes dos serviços prestados pelo profissional
        encarregado de executar o serviço contratado neste instrumento.
      </p>
      <p>
        5.3. As Partes não possuem obrigação de exclusividade uma com a outra.
      </p>
      <p>
        5.4. Este Contrato não vincula nenhuma das Partes com relação à outra
        quanto aos resultados econômicos presentes ou futuros de seus
        respectivos negócios, não sendo, pois, nenhuma delas responsável com
        relação à outra, por tais resultados, seja durante a vigência deste
        Contrato ou mesmo após o seu término, a qualquer título.
      </p>
      <v-text tag="h5"><b>CLÁUSULA SEXTA – DA VIGÊNCIA</b></v-text>
      <p>
        6.1. O presente contrato tem vigência por prazo determinado, até o
        cumprimento integral das horas contratadas e dos adendos de horas
        presentes em seus eventuais termos aditivos, podendo se estender no
        máximo pelo período de 6 (seis) meses além da data prevista para a
        conclusão das horas contratadas.
      </p>
      <v-text tag="h5"><b>CLÁUSULA SÉTIMA – DA RESCISÃO</b></v-text>
      <p>
        7.1. O presente Contrato poderá ser rescindido, de pleno direito, nas
        seguintes hipóteses:
      </p>
      <p>
        7.1.1. A qualquer tempo, em caso de infração ou inadimplência às suas
        cláusulas e condições, independentemente de interpelação judicial ou
        extrajudicial, assim como em caso de pedido de recuperação judicial,
        extrajudicial e/ou falência de qualquer uma das Partes, nos termos da
        Lei nº 11.101 de 09/02/2005;
      </p>
      <p>
        7.1.1.1. Na hipótese de rescisão por inadimplemento da
        <b>CONTRATANTE</b>, esta fica obrigada a pagar proporcionalmente pelos
        serviços parciais executados, com base no volume de horas de trabalho
        realizadas até o momento pelo Vibbrante.
      </p>
      <p>
        7.1.2. Por interesse de qualquer das Partes, a qualquer tempo, mediante
        aviso formal à outra com 15 (quinze) dias de antecedência.
      </p>
      <p>
        7.1.3. Caso as Partes infringirem obrigação legal ou descumprirem
        qualquer das cláusulas do presente Contrato.
      </p>
      <p>
        7.2. Caso seja caracterizada má-fé na conduta da <b>CONTRATANTE</b>, ou
        ainda, cancelamento reiterado de Contrato antes de sua finalização, a
        <b>CONTRATADA</b> se reserva ao direito, a seu exclusivo critério, sem a
        necessidade de aviso prévio, de efetivar a exclusão definitiva do
        <b>CONTRATANTE</b> na Plataforma Vibbra.
      </p>
      <v-text tag="h5"
        ><b>CLÁUSULA OITAVA – DA AUTONOMIA ENTRE AS PARTES</b></v-text
      >
      <p>
        8.1. Ambas as Partes expressamente reconhecem que o único vínculo
        jurídico entre elas resulta do presente Contrato ou de contratos
        formalmente assinados entre elas. As Partes declaram e concordam, ainda,
        que este Contrato é de natureza estritamente civil, não implicando na
        existência de qualquer vínculo empregatício, societário, associativo,
        cooperativo, empregatício ou econômico entre si, seus administradores,
        empregados ou contratados, inclusive e especialmente para desobrigar
        qualquer das Partes em relação a encargos trabalhistas, previdenciários
        (INSS) ou fundiários (FGTS) da outra Parte, seus administradores,
        empregados ou contratados.
      </p>
      <v-text tag="h5"><b>CLÁUSULA NONA – CONFIDENCIALIDADE</b></v-text>
      <p>
        9.1. A <b>CONTRATADA</b> se obriga e se compromete por si, seus
        administradores, colaboradores, contratados, empregados, representantes
        e prepostos, a tratar todas as informações recebidas da
        <b>CONTRATANTE</b>, durante a execução do objeto do presente Contrato,
        como confidenciais, permanecendo tal obrigação em vigor a todo tempo,
        mesmo após o término deste instrumento.
      </p>
      <p>
        9.2. Considera-se informação recebida: a escrita, oral, ou em qualquer
        outra forma, corpórea ou não, patenteada ou não, de natureza técnica,
        operacional, comercial, financeira, jurídica, know-how, invenções,
        marcas e patentes, procedimentos, processos, rotinas, práticas, fórmulas
        e desenhos (patenteáveis ou não), planos de negócios, planos comerciais,
        planos de expansão, planos de marketing e vendas, estratégias
        comerciais, descobertas, ideias, conceitos, técnicas e experiência
        acumulada, projetos, propriedade intelectual, especificações, diagramas,
        modelos, amostras, fluxogramas, programas de computador, componentes de
        software, discos, fitas, nomes de clientes e quaisquer outras
        informações transmitidas pela <b>CONTRATANTE</b> à <b>CONTRATADA</b>.
      </p>
      <p>
        9.3. As obrigações instituídas por esta cláusula somente não serão
        aplicadas no caso das informações já forem de domínio público no momento
        da revelação ou que venham a tornarem-se legalmente públicas por
        terceiros que não as tiverem recebido sob a vigência de uma obrigação de
        sigilo.
      </p>
      <v-text tag="h5"><b>CLÁUSULA DÉCIMA – PROPRIEDADE INTELECTUAL</b></v-text>
      <p>
        10.1. A utilização de direitos de propriedade intelectual que apareçam
        ou estejam de alguma forma ligados à prestação de serviços ora
        contratados, deverão ter utilização restrita ao objeto do presente
        Contrato, de acordo com as condições estabelecidas, devendo as Partes
        preservar tais direitos da contraparte, seja de suas marcas, direitos
        autorais, programas de computador, bem como demais direitos de
        propriedade intelectual aqui mencionados e relacionados à Plataforma
        Vibbra.
      </p>
      <p>
        10.2. Nenhuma das disposições do presente Contrato deverá ser
        interpretada como forma de licença ou cessão de direitos de propriedade
        intelectual por qualquer das Partes. Com efeito, cada uma das Partes
        permanecerá a única e exclusiva titular de seus respectivos direitos de
        propriedade intelectual.
      </p>
      <v-text tag="h5"
        ><b>CLÁUSULA DÉCIMA PRIMEIRA – DOS CASOS OMISSOS</b></v-text
      >
      <p>
        11.1. Os casos omissos ou eventos isolados serão resolvidos de comum
        acordo, mediante reunião para tal finalidade, devendo ser elaborado
        termo aditivo a este Contrato e assinado pelas Partes contratantes, ou
        aplicar-se-á o disposto na legislação vigente no País, principalmente
        nas Leis no. 9.279/96, 9.609/98 e 9.610/98.
      </p>
      <v-text tag="h5"
        ><b>CLÁUSULA DÉCIMA SEGUNDA – COMUNICAÇÃO ENTRE AS PARTES</b></v-text
      >
      <p>
        12.1. As Partes pactuam que as intimações e notificações a serem feitas
        de parte a parte, poderão efetivar-se através da Plataforma Vibbra, de
        e-mail ou via postal com aviso de recepção.
      </p>
      <p>
        12.2. Para efeito de citação ou notificação da <b>CONTRATANTE</b>,
        consideram-se como seus representantes não só os indicados no artigo
        242, parágrafo primeiro, do Código de Processo Civil, como qualquer
        outro funcionário seu que, mediante delegação gerencial, expressa ou
        tácita, responda operacionalmente pelo estabelecimento.
      </p>
      <v-text tag="h5"
        ><b>CLÁUSULA DÉCIMA TERCEITA – DOCUMENTOS INTEGRANTES</b></v-text
      >
      <p>
        13.1. Constituem parte integrante e complementar do presente contrato,
        como se aqui estivessem integralmente transcritos, os seguintes
        documentos, cujo acesso se dá por meio do sítio eletrônico da
        <b>CONTRATADA</b>, ao qual a <b>CONTRATANTE</b> afirma conhecê-los e
        aceitá-los:
      </p>
      <p>
        (a)
        <v-link :to="{ name: 'terms' }" target="_blank"
          ><b>Termos e Condições Gerais de Uso da Plataforma Vibbra</b></v-link
        >;
      </p>
      <p>
        (b)
        <v-link :to="{ name: 'privacy' }" target="_blank"
          ><b>Política de Privacidade</b></v-link
        >;
      </p>
      <v-text tag="h5"
        ><b>CLÁUSULA DÉCIMA QUARTA – CONDIÇÕES GERAIS DO CONTRATO</b></v-text
      >
      <p>
        14.1. Este Contrato vincula as partes e seus sucessores, sejam eles a
        qualquer título.
      </p>
      <p>
        14.2. Este Contrato e quaisquer direitos concedidos de acordo com o
        presente não podem ser transferidos ou cedidos pelo <b>CONTRATANTE</b>,
        mas podem ser transferidos pela <b>CONTRATADA</b>, sob notificação
        prévia.
      </p>
      <p>
        14.3. Todas as disposições deste Contrato que prevejam a observância de
        obrigações ou responsabilidades após a rescisão ou extinção deste
        Contrato, subsistirão a sua rescisão ou extinção e continuarão em pleno
        vigor e efeito, em especial no que tange à propriedade intelectual,
        confidencialidade e privacidade de dados e informações.
      </p>
      <p>
        14.4. Se alguma cláusula deste instrumento for considerada ilegal, nula
        ou incapaz de ser cumprida por qualquer motivo, esta previsão será
        considerada uma cláusula independente da parte remanescente deste
        Contrato e não afetará a validade ou a aplicabilidade do cumprimento dos
        termos do restante do presente.
      </p>
      <p>
        14.5. O presente Contrato e o cumprimento das obrigações nele previstas
        serão regidos pelas leis da República Federativa do Brasil e
        interpretados de acordo suas disposições.
      </p>
      <p>
        14.6. Fica eleito o Foro Comarca da Capital do Estado de Santa Catarina
        para dirimir quaisquer pleitos oriundos do presente Contrato, com
        renúncia a qualquer outro, por mais privilegiado que seja ou venha a
        sê-lo.
      </p>
    </div>
    <div v-else>
      <v-text tag="h5"><b>CLÁUSULA PRIMEIRA – DO OBJETO</b></v-text>
      <p>
        1.1. A <b>CONTRATADA</b> oferece à <b>CONTRATANTE</b> por meio da
        Plataforma Vibbra, a prestação de serviços especializados relacionados à
        Tecnologia da Informação (TI), por meio de contratação de horas de
        trabalho, conforme detalhes indicados no "ANEXO I" deste instrumento.
      </p>
      <p>
        1.2. Eventuais adendos de horas de trabalho, ocorrerão por meio de
        termos aditivos a serem firmados pelas Partes, e serão consideradas como
        parte integrante do presente instrumento.
      </p>
      <v-text tag="h5"
        ><b>CLÁUSULA SEGUNDA – DO FUNCIONAMENTO DOS SERVIÇOS</b></v-text
      >
      <p>
        2.1. A <b>CONTRATADA</b> em cumprimento ao objeto deste instrumento,
        executará atividades que serão solicitadas pelo
        <b>Usuário Contratante</b> presente na Plataforma Vibbra, conforme
        descrito nos
        <v-link :to="{ name: 'terms' }" target="_blank"
          ><b>Termos e Condições Gerais de Uso</b></v-link
        >, contanto que não extrapole as horas contratadas por esse instrumento
        ou eventuais termos aditivos vinculados ao mesmo.
      </p>
      <p>
        2.2. A <b>CONTRATADA</b> deverá reportar periodicamente um relatório de
        atividades concluídas, destacando o número de horas e minutos empregados
        na execução de cada atividade, através da Plataforma Vibbra. O relatório
        em questão servirá como comprovante de conclusão de atividades
        realizadas até o momento do registro na Plataforma.
      </p>
      <p>
        2.3. A <b>CONTRATANTE</b> pode eventualmente auxiliar no processo de
        acompanhamento da execução dos serviços contratados, adotando
        providências cabíveis para a correção de quaisquer falhas ou anomalias
        detectadas.
      </p>
      <v-text tag="h5"><b>CLÁUSULA TERCEIRA – DO PAGAMENTO</b></v-text>
      <p>
        3.1. À título de remuneração pelas atividades desempenhadas, a
        <b>CONTRATANTE</b> pagará à <b>CONTRATADA</b> a quantia total de horas
        trabalhadas, ou seja, executadas e apontadas na Plataforma Vibbra,
        considerando que hajam horas pré-pagas pelo Usuário Contratante e
        anuência prévia do mesmo, já inclusos todos os impostos pertinentes,
        referentes aos serviços prestados.
      </p>
      <p>
        3.2 A forma de pagamento ocorrerá conforme descrito no item 5 dos
        <v-link :to="{ name: 'terms' }" target="_blank"
          ><b>Termos e Condições Gerais de Uso</b></v-link
        >
        da Plataforma Vibbra.
      </p>
      <v-text tag="h5"
        ><b>CLÁUSULA QUARTA – DAS OBRIGAÇÕES E RESPONSABILIDADES</b></v-text
      >
      <p>
        4.1. A <b>CONTRATADA</b> obriga-se a dispensar conduta orientada pelos
        padrões recomendados pela boa técnica e zelo profissional, na condução
        das questões submetidas à sua responsabilidade, ficando a cargo da
        <b>CONTRATANTE</b>, nas questões que julgar conveniente, definir quando
        for o caso, o procedimento a ser adotado, observados os preceitos
        definidos no presente contrato.
      </p>
      <p>
        4.2. A <b>CONTRATADA</b> responsabiliza-se pela correta prestação dos
        serviços objeto deste instrumento.
      </p>
      <p>
        4.3. Na hipótese de qualquer tentativa direta ou indireta de abordagem,
        negociação e/ou contratação por parte de outro indivíduo (o denominado
        "Usuário Contratante" na Plataforma), que não teria chegado aos serviços
        da <b>CONTRATADA</b> por outro meio, a não ser pela Plataforma Vibbra, a
        <b>CONTRATADA</b> deve obrigatoriamente notificar a
        <b>CONTRATANTE</b> por e-mail, informando as intenções alheias, para que
        seja adotado as medidas cabíveis.
      </p>
      <p>
        4.4. A <b>CONTRATANTE</b> é responsável pelo pagamento do valor hora
        acordado, em razão do volume de horas executadas, conforme acordado no
        presente instrumento.
      </p>
      <p>
        4.5. A <b>CONTRATADA</b> cumprirá rigorosamente com as disposições deste
        contrato, em conformidade com todas as condições aqui estabelecidas, bem
        como o disposto nos
        <v-link :to="{ name: 'terms' }" target="_blank"
          ><b>Termos e Condições Gerais de Uso</b></v-link
        >
        da Plataforma e na
        <v-link :to="{ name: 'privacy' }" target="_blank"
          ><b>Política de Privacidade</b></v-link
        >
        disponibilizados, e ainda, com toda e qualquer exigência legal aplicável
        ao presente caso.
      </p>
      <p>
        4.6. A <b>CONTRATANTE</b> se compromete em auxiliar adotando todas as
        providências cabíveis para a correção de quaisquer falhas ou anomalias
        detectadas, a fim de assegurar o devido cumprimento dos serviços
        contratados.
      </p>
      <v-text tag="h5"
        ><b>CLÁUSULA QUINTA – DA LIMITAÇÃO DE RESPONSABILIDADE</b></v-text
      >
      <p>
        5.1. No caso da <b>CONTRATANTE</b> ser envolvida em qualquer demanda
        judicial por ação ou omissão comprovada da <b>CONTRATADA</b>, todas as
        despesas judiciais e extrajudiciais, incluindo honorários advocatícios,
        pagas pela <b>CONTRATANTE</b>, provenientes da referida demanda, deverão
        ser reembolsadas pela <b>CONTRATADA</b>.
      </p>
      <p>
        5.2. As partes não possuem obrigação de exclusividade uma com a outra.
      </p>
      <p>
        5.3. Este Contrato não vincula nenhuma das partes com relação à outra
        quanto aos resultados econômicos presentes ou futuros de seus
        respectivos negócios. A <b>CONTRATADA</b> reconhece que a Plataforma
        Vibbra é uma ferramenta auxiliar à prestação dos seus serviços, não
        sendo essencial para o desenvolvimento de suas atividades econômicas.
      </p>
      <v-text tag="h5"><b>CLÁUSULA SEXTA – DA VIGÊNCIA</b></v-text>
      <p>
        6.1. O presente contrato tem vigência por prazo determinado, até o
        cumprimento integral das horas contratadas e dos adendos de horas
        presentes em seus eventuais termos aditivos, podendo se estender no
        máximo pelo período de 6 (seis) meses além da data prevista para a
        conclusão das horas contratadas.
      </p>
      <v-text tag="h5"><b>CLÁUSULA SÉTIMA – DA RESCISÃO</b></v-text>
      <p>
        7.1. O presente Contrato poderá ser rescindido, de pleno direito, nas
        seguintes hipóteses:
      </p>
      <p>
        7.1.1. A qualquer tempo, em caso de infração ou inadimplência às suas
        cláusulas e condições, independentemente de interpelação judicial ou
        extrajudicial, assim como em caso de pedido de recuperação judicial,
        extrajudicial e/ou falência de qualquer uma das partes, nos termos da
        Lei nº 11.101 de 09/02/2005;
      </p>
      <p>
        7.1.2. Por interesse de qualquer das partes, a qualquer tempo, mediante
        aviso formal à outra com 15 (quinze) dias de antecedência.
      </p>
      <p>
        7.1.3. Caso as partes infringirem obrigação legal ou descumprirem
        qualquer das cláusulas do presente contrato.
      </p>
      <p>
        7.1.4. Caso seja transferido o contrato à terceiros por parte da
        <b>CONTRATADA</b>, no todo ou em parte, sem aprovação expressa da
        <b>CONTRATANTE</b>.
      </p>
      <p>
        7.2. Caso seja caracterizada má-fé na conduta da <b>CONTRATADA</b>, ou
        ainda, cancelamento reiterado de contrato antes de sua finalização, a
        <b>CONTRATANTE</b> se reserva o direito, a seu exclusivo critério, sem a
        necessidade de aviso prévio, de efetivar a exclusão definitiva do
        <b>CONTRATADA</b> na Plataforma Vibbra.
      </p>
      <v-text tag="h5"
        ><b>CLÁUSULA OITAVA – DA AUTONOMIA ENTRE AS PARTES</b></v-text
      >
      <p>
        8.1. Ambas as partes expressamente reconhecem que o único vínculo
        jurídico entre elas resulta do presente Contrato ou de contratos
        formalmente assinados entre elas. As partes declaram e concordam, ainda,
        que este Contrato é de natureza estritamente civil, não implicando na
        existência de qualquer vínculo empregatício, societário, associativo,
        cooperativo, empregatício ou econômico entre si, seus administradores,
        empregados ou contratados, inclusive e especialmente para desobrigar
        qualquer das partes em relação a encargos trabalhistas, previdenciários
        (INSS) ou fundiários (FGTS) da outra Parte, seus administradores,
        empregados ou contratados.
      </p>
      <v-text tag="h5"><b>CLÁUSULA NONA – CONFIDENCIALIDADE</b></v-text>
      <p>
        9.1. A <b>CONTRATADA</b> se obriga e compromete-se por si, seus
        administradores, colaboradores, contratados, empregados, representantes
        e prepostos a tratar todas as informações recebidas por meio dos
        serviços a serem desempenhados, durante a execução do objeto do presente
        contrato, como confidenciais, permanecendo tal obrigação em vigor a todo
        tempo, mesmo após o término deste instrumento.
      </p>
      <p>
        9.2. Considera-se informação recebida: a escrita, oral, ou em qualquer
        outra forma, corpórea ou não, patenteada ou não, de natureza técnica,
        operacional, comercial, financeira, jurídica, know-how, invenções,
        marcas e patentes, procedimentos, processos, rotinas, práticas, fórmulas
        e desenhos (patenteáveis ou não), planos de negócios, planos comerciais,
        planos de expansão, planos de marketing e vendas, estratégias
        comerciais, descobertas, ideias, conceitos, técnicas e experiência
        acumulada, projetos, propriedade intelectual, especificações, diagramas,
        modelos, amostras, fluxogramas, programas de computador, componentes de
        software, discos, fitas, nomes de clientes e quaisquer outras
        informações transmitidas na execução do serviços pela <b>CONTRATADA</b>.
      </p>
      <p>
        9.3. As obrigações instituídas por esta cláusula somente não serão
        aplicadas no caso das informações já forem de domínio público no momento
        da revelação ou que venham a tornarem-se legalmente públicas por
        terceiros que não as tiverem recebido sob a vigência de uma obrigação de
        sigilo.
      </p>
      <v-text tag="h5"><b>CLÁUSULA DÉCIMA – PROPRIEDADE INTELECTUAL</b></v-text>
      <p>
        10.1. A utilização de direitos de propriedade intelectual que apareçam
        ou estejam de alguma forma ligados à prestação de serviços ora
        contratados, deverão ter utilização restrita ao objeto do presente
        Contrato, de acordo com as condições estabelecidas, devendo as partes
        preservar tais direitos da contraparte, seja de suas marcas, direitos
        autorais, programas de computador, bem como demais direitos de
        propriedade intelectual aqui mencionados e relacionados à Plataforma
        Vibbra.
      </p>
      <p>
        10.2. Nenhuma das disposições do presente Contrato deverá ser
        interpretada como forma de licença ou cessão de direitos de propriedade
        intelectual por qualquer das partes. Com efeito, cada uma das partes
        permanecerá a única e exclusiva titular de seus respectivos direitos de
        propriedade intelectual.
      </p>
      <v-text tag="h5"
        ><b>CLÁUSULA DÉCIMA PRIMEIRA – DOS CASOS OMISSOS</b></v-text
      >
      <p>
        11.1. Os casos omissos ou eventos isolados serão resolvidos de comum
        acordo, mediante reunião para tal finalidade, devendo ser elaborado
        termo aditivo a este contrato e assinado pelas partes contratantes, ou
        aplicar-se-á o disposto na legislação vigente no País, principalmente
        nas Leis no. 9.279/96, 9.609/98 e 9.610/98.
      </p>
      <v-text tag="h5"
        ><b>CLÁUSULA DÉCIMA SEGUNDA – COMUNICAÇÃO ENTRE AS PARTES</b></v-text
      >
      <p>
        12.1. As partes pactuam que as intimações e notificações a serem feitas
        de parte a parte, poderão efetivar-se através da Plataforma Vibbra, de
        e-mail ou via postal com aviso de recepção.
      </p>
      <p>
        12.2. Para efeito de citação ou notificação da <b>CONTRATADA</b>,
        consideram-se como seus representantes não só os indicados no artigo
        242, parágrafo primeiro, do Código de Processo Civil, como qualquer
        outro funcionário seu que, mediante delegação gerencial, expressa ou
        tácita, responda operacionalmente pelo estabelecimento.
      </p>
      <v-text tag="h5"
        ><b>CLÁUSULA DÉCIMA TERCEITA – DOCUMENTOS INTEGRANTES</b></v-text
      >
      <p>
        13.1. Constituem parte integrante e complementar do presente contrato,
        como se aqui estivessem integralmente transcritos, os seguintes
        documentos, cujo acesso se dá por meio do sítio eletrônico da
        <b>CONTRATANTE</b>, ao qual a <b>CONTRATADA</b> afirma conhecê-los e
        aceitá-los:
      </p>
      <p>
        (a)
        <v-link :to="{ name: 'terms' }" target="_blank"
          ><b>Termos e Condições Gerais de Uso da Plataforma Vibbra</b></v-link
        >;
      </p>
      <p>
        (b)
        <v-link :to="{ name: 'privacy' }" target="_blank"
          ><b>Política de Privacidade</b></v-link
        >;
      </p>
      <v-text tag="h5"
        ><b>CLÁUSULA DÉCIMA QUARTA – CONDIÇÕES GERAIS DO CONTRATO</b></v-text
      >
      <p>
        14.1. Este Contrato vincula as partes e seus sucessores, sejam eles a
        qualquer título.
      </p>
      <p>
        14.2. Este Contrato e quaisquer direitos concedidos de acordo com o
        presente não podem ser transferidos ou cedidos pelas partes, sem
        expressa autorização.
      </p>
      <p>
        14.3. Todas as disposições deste Contrato que prevejam a observância de
        obrigações ou responsabilidades após a rescisão ou extinção deste
        Contrato, subsistirão a sua rescisão ou extinção e continuarão em pleno
        vigor e efeito, em especial no que tange à propriedade intelectual,
        confidencialidade e privacidade de dados e informações.
      </p>
      <p>
        14.4. Se alguma cláusula deste instrumento for considerada ilegal, nula
        ou incapaz de ser cumprida por qualquer motivo, esta previsão será
        considerada uma cláusula independente da parte remanescente deste
        Contrato e não afetará a validade ou a aplicabilidade do cumprimento dos
        termos do restante do presente.
      </p>
      <p>
        14.5. Qualquer omissão ou tolerância das partes na exigência do
        cumprimento dos termos e condições deste instrumento ou no exercício das
        prerrogativas dele decorrentes, não constituirá novação ou renúncia ao
        direito de aplicar as sanções previstas neste contrato ou decorrentes de
        lei.
      </p>
      <p>
        14.6. O presente Contrato e o cumprimento das obrigações nele previstas
        serão regidos pelas leis da República Federativa do Brasil e
        interpretados de acordo suas disposições.
      </p>
      <p>
        14.7. Fica eleito o Foro Comarca da Capital do Estado de Santa Catarina
        para dirimir quaisquer pleitos oriundos do presente Contrato, com
        renúncia a qualquer outro, por mais privilegiado que seja ou venha a
        sê-lo.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    profile: String,
  },
};
</script>

<style lang="css"></style>



// WEBPACK FOOTER //
// src/parts/modules/contract.vue